import { Input } from "@mui/material";
import React from "react";

export default function InputComponent(props) {
  const isFieldEmpty = (value) => {
    return value === "" || value === null || value === undefined;
  };
  const handleChange = (event) => {
    props.onChange(event.target.value);
  };
  return (
    <div className="input-label-container">
      <div className="input-label">
        {" "}
        {props.title}{" "}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>

      <Input
        variant="outlined"
        // placeholder="Search client…"
        onChange={handleChange}
        value={props.value}
        style={{
          width: props.width,
          height: "40px",
          borderRadius: "5px",
          background: "#FFFFFF",
          marginTop: "2px",
          paddingLeft: "8px",
          border:
            props.showValidation && isFieldEmpty(props.value)
              ? "1px solid red"
              : "none", // Activation de la bordure rouge
        }}
        placeholder={props.placeholder}
        error={props.showValidation && isFieldEmpty(props.value)} // Ajout de l'erreur MUI
        helperText={
          props.showValidation && isFieldEmpty(props.value)
            ? "This field is required"
            : ""
        } // Message d'aide si vide
      />
    </div>
  );
}
